import { Injectable } from "@angular/core";

interface StagedCredentials {
  email: string;
  password: string;
}

/**
 * Carries a plaintext password across a single client-side route change (e.g.
 * onboarding-password -> login) so the destination page can auto-submit it.
 * Kept in memory only - never written to the URL, storage, or history.state -
 * and cleared on first read so it can't be replayed or leak across a refresh.
 */
@Injectable({
  providedIn: "root",
})
export class CredentialHandoffService {
  private staged: StagedCredentials | null = null;

  public stage(email: string, password: string): void {
    console.info("CredentialHandoffService.stage - staging credentials in memory for email:", email);
    this.staged = { email, password };
  }

  public consume(): StagedCredentials | null {
    const credentials = this.staged;
    this.staged = null;
    if (credentials) {
      console.info("CredentialHandoffService.consume - staged credentials found and consumed for email:", credentials.email);
    } else {
      console.info("CredentialHandoffService.consume - no staged credentials present.");
    }
    return credentials;
  }
}
